import styled from 'styled-components';

export const QuestionTipContainer = styled('div')`
    position: relative;
    cursor: pointer;
    width: 12px;
    height: 12px;

    .question-icon {
        vertical-align: top !important;
    }

    .tip {
        visibility: hidden;
        opacity: 0;
        transition: visibility 0.3s ease 0.3s, opacity 0.3s ease 0.3s;

        width: 346px;
        position: absolute;
        top: -5px;
        left: 40px;
        padding: 12px;
        // border-radius: 3px;
        border: none;
        box-shadow: 4px 6px 6px rgba(0, 0, 0, 0.12);
        background: #fffbc4;
        color: black;
        font-size: 10px;
        font-family: 'Proxima Nova';
        line-height: 12px;
        white-space: pre-wrap;
        z-index: 2;
        text-wrap: wrap;
        word-break: break-word;
        -ms-word-break: break-all;
        overflow-wrap: break-word;

        div {
            margin-bottom: 10px;
        }
    }

    &:hover {
        .tip {
            visibility: visible;
            opacity: 1;
            transition-delay: 0s;
        }
    }
`;
